"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var error_boundary_1 = require("./error-boundary");

function withErrorBoundary(Component) {
  return function (_super) {
    __extends(class_1, _super);

    function class_1() {
      return _super !== null && _super.apply(this, arguments) || this;
    }

    class_1.prototype.render = function () {
      return react_1.default.createElement(error_boundary_1.ErrorBoundary, null, react_1.default.createElement(Component, null));
    };

    return class_1;
  }(react_1.default.Component);
}

exports.withErrorBoundary = withErrorBoundary;